import { getFetch } from "../../utils/fetch";

async function getEquipment(term) {
  const data = await getFetch(`/ReportWeb/Equipment?term=${term}`);
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}

export { getEquipment };
